import { render, staticRenderFns } from "./allotChai.vue?vue&type=template&id=21233906&scoped=true&"
import script from "./allotChai.vue?vue&type=script&lang=js&"
export * from "./allotChai.vue?vue&type=script&lang=js&"
import style0 from "./allotChai.vue?vue&type=style&index=0&id=21233906&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21233906",
  null
  
)

export default component.exports